// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7be96f8d","732":"1930e22c","977":"d3dc8f56"}[chunkId] + ".chunk.js";
};